import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "itemCount", "grandTotal", "totalEarning", "itemTotal", "itemEarning"]
  static values = {
    variants: Array,
    currencySymbol: String
  }

  connect() {
    this.updateSummary()

    // Listen for order-item:calculated events
    this.element.addEventListener('order-item:calculated', () => {
      this.updateSummary()
    })
  }

  // Called when any item total changes
  itemTotalTargetConnected() {
    this.updateSummary()
  }

  itemTotalTargetDisconnected() {
    this.updateSummary()
  }

  itemEarningTargetConnected() {
    this.updateSummary()
  }

  itemEarningTargetDisconnected() {
    this.updateSummary()
  }

  updateSummary() {
    const visibleItems = this.getVisibleItems()
    let total = 0
    let earning = 0
    let count = 0

    visibleItems.forEach(item => {
      const totalInput = item.querySelector('[data-order-summary-target="itemTotal"]')
      const earningInput = item.querySelector('[data-order-summary-target="itemEarning"]')

      if (totalInput) {
        total += parseFloat(totalInput.value) || 0
        count++
      }
      if (earningInput) {
        earning += parseFloat(earningInput.value) || 0
      }
    })

    if (this.hasItemCountTarget) {
      this.itemCountTarget.textContent = count
    }
    if (this.hasGrandTotalTarget) {
      const symbol = this.currencySymbolValue || '$'
      this.grandTotalTarget.textContent = `${symbol}${total.toFixed(2)}`
    }
    if (this.hasTotalEarningTarget) {
      const symbol = this.currencySymbolValue || '$'
      this.totalEarningTarget.textContent = `${symbol}${earning.toFixed(2)}`
    }
  }

  getVisibleItems() {
    if (!this.hasContainerTarget) return []

    const allItems = this.containerTarget.querySelectorAll('.nested-fields')
    return Array.from(allItems).filter(item => {
      const destroyInput = item.querySelector('input[name*="_destroy"]')
      return item.style.display !== 'none' && (!destroyInput || destroyInput.value !== '1')
    })
  }
}
